import { AuthRepositoryImpl } from "@/data/repo-Implement/auth-repository-impl";
import { AppAccountSettingRepositoryImpl } from "@/data/repo-Implement/app-account-setting-repository-impl";
import { DashboardRepositoryImpl } from "@/data/repo-Implement/dashboard-repository-impl";
import { DoctorRepositoryImpl } from "@/data/repo-Implement/doctor-repository-impl";
import { HospitalRepositoryImpl } from "@/data/repo-Implement/hospital-repository-impl";
import { LoginRepositoryImpl } from "@/data/repo-Implement/login-repository-impl";
import { MockAuthRepositoryImpl } from "@/data/repo-Implement/mock/mock-auth-repository-impl";
import { MockDashboardRepositoryImpl } from "@/data/repo-Implement/mock/mock-dashboard-repository-impl";
import { MockDoctorRepositoryImpl } from "@/data/repo-Implement/mock/mock-doctor-repository-impl";
import { MockHospitalRepositoryImpl } from "@/data/repo-Implement/mock/mock-hospital-repository-impl";
import { MockLoginRepositoryImpl } from "@/data/repo-Implement/mock/mock-login-repository-impl";
import { MockOperationLogRepositoryImpl } from "@/data/repo-Implement/mock/mock-operation-log-repository-impl";
import { MockPatientRepositoryImpl } from "@/data/repo-Implement/mock/mock-patient-repository-impl";
import { MockPrescriptionRepositoryImpl } from "@/data/repo-Implement/mock/mock-prescription-repository-impl";
import { MockTreatmentRepositoryImpl } from "@/data/repo-Implement/mock/mock-treatment-repository-impl";
import { MockUserPasswordRepositoryImpl } from "@/data/repo-Implement/mock/mock-user-password-repository-impl";
import { MockUserRepositoryImpl } from "@/data/repo-Implement/mock/mock-user-repository-impl";
import { OperationLogRepositoryImpl } from "@/data/repo-Implement/operation-log-repository-impl";
import { PatientRepositoryImpl } from "@/data/repo-Implement/patient-repository-impl";
import { PrescriptionRepositoryImpl } from "@/data/repo-Implement/prescription-repository-impl";
import { TreatmentRepositoryImpl } from "@/data/repo-Implement/treatment-repository-impl";
import { UserPasswordRepositoryImpl } from "@/data/repo-Implement/user-password-repository-impl";
import { UserRepositoryImpl } from "@/data/repo-Implement/user-repository-impl";
import { secureStorage } from "@/data/secure-storage";
import { AppAccountSettingSource } from "@/data/source/app-account-setting-source";
import { AuthSource } from "@/data/source/auth-source";
import { DashboardSource } from "@/data/source/dashboard-source";
import { DoctorSource } from "@/data/source/doctor-source";
import { HospitalSource } from "@/data/source/hospital-source";
import { LoginSource } from "@/data/source/login-source";
import { OperationLogSource } from "@/data/source/operation-log-source";
import { PatientSource } from "@/data/source/patient-source";
import { PrescriptionSource } from "@/data/source/prescription-source";
import { TreatmentSource } from "@/data/source/treatment-source";
import { UserPasswordSource } from "@/data/source/user-password-source";
import { UserSource } from "@/data/source/user-source";
import { URLList } from "@/data/url_list";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { DashboardRepository } from "@/domain/repository/dashboard-repository";
import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { LoginRepository } from "@/domain/repository/login-repository";
import { OperationLogRepository } from "@/domain/repository/operation-log-repository";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { UserRepository } from "@/domain/repository/user-repository";
import { AddHospitalUsecase } from "@/domain/usecase/admin/hospital-manage/add-hospital-usecase";
import { DeleteHospitalUsecase } from "@/domain/usecase/admin/hospital-manage/delete-hospital-usecase";
import { FetchHospitalListUsecase } from "@/domain/usecase/admin/hospital-manage/fetch-hospital-list-usecase";
import { FetchHospitalUsecase } from "@/domain/usecase/admin/hospital-manage/fetch-hospital-usecase";
import { FetchOperationLogUsecase } from "@/domain/usecase/admin/operation-log-usecase";
import { CreateTempUserUsecase } from "@/domain/usecase/admin/user-manage/create-temp-user-usecase";
import { ChangePasswordByFindLinkUsecase } from "@/domain/usecase/common/find-password/change-password-by-find-link-usecase";
import { ChangePasswordByVerificationTokenUsecase } from "@/domain/usecase/common/find-password/change-password-by-verification-token-usecase";
import { CheckFindSnPhoneAuthCodeUsecase } from "@/domain/usecase/common/find-password/check-find-sn-phone-auth-code-usecase";
import { BrowserEnvironmentCheckUsecase } from "@/domain/usecase/common/auth/browser-environment-check-usecase";
import { ExchangeAESKeyUsecase } from "@/domain/usecase/common/auth/exchange-aes-key-usecase";
import { InitDoctorPasswordSettingUsecase } from "@/domain/usecase/common/auth/init-doctor-password-setting-usecase";
import { IssueFindSnPhoneAuthCodeUsecase } from "@/domain/usecase/common/find-password/issue-find-sn-phone-auth-code-usecase";
import { IssueWebFindSnEmailAuthCodeUsecase } from "@/domain/usecase/common/find-password/issue-web-find-sn-email-auth-code-usecase";
import { IssueWebFindSnLinkUsecase } from "@/domain/usecase/common/find-password/issue-web-find-sn-link-usecase";
import { RefreshWebSessionUsecase } from "@/domain/usecase/common/auth/refresh-web-session-usecase";
import { SendResetSnEmailUsecase } from "@/domain/usecase/common/find-password/send-reset-sn-email-usecase";
import { FetchWebUserInfoUsecase } from "@/domain/usecase/common/header/fetch-web-user-info-usecase";
import { ChangePasswordUsecase } from "@/domain/usecase/common/login/change-password-usecase";
import { LoginUsecase } from "@/domain/usecase/common/login/login-usecase";
import { LogoutUsecase } from "@/domain/usecase/common/login/logout-usecase";
import { AddAppAccountUsecase } from "@/domain/usecase/app-account-setting/add-app-account-usecase";
import { CheckUserIdAvailableUsecase } from "@/domain/usecase/app-account-setting/check-user-id-available-usecase";
import { CheckUserNameBySmsTokenForLoginAccountUsecase } from "@/domain/usecase/app-account-setting/check-user-name-by-sms-token-for-login-account-usecase";
import { FetchPrivacyMdFileUsecase } from "@/domain/usecase/app-account-setting/fetch-privacy-md-file-usecase";
import { FetchTermsOfServiceFileUsecase } from "@/domain/usecase/app-account-setting/fetch-terms-of-service-file-usecase";
import { IsExistAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/is-exist-authorized-token-usecase";
import { RemoveAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/remove-authorized-token-usecase";
import { SaveTermsConsentUsecase } from "@/domain/usecase/app-account-setting/save-terms-consent-usecase";
import { SetAuthorizedTokenUsecase } from "@/domain/usecase/app-account-setting/set-authorized-token-usecase";
import { CreateCroUsecase } from "@/domain/usecase/doctor/create-cro-usecase";
import { CreateMedicalExpertUsecase } from "@/domain/usecase/doctor/create-medical-expert-usecase";
import { CreateNurseUsecase } from "@/domain/usecase/doctor/create-nurse-usecase";
import { ActivateDoctorUsecase } from "@/domain/usecase/doctor/activate-doctor-usecase";
import { DeactivateDoctorUsecase } from "@/domain/usecase/doctor/deactivate-doctor-usecase";
import { FetchChargeDoctorListUsecase } from "@/domain/usecase/doctor/fetch-charge-doctor-list-usecase";
import { FetchDoctorListUsecase } from "@/domain/usecase/doctor/fetch-doctor-list-usecase";
import { FetchDoctorUsecase } from "@/domain/usecase/doctor/fetch-doctor-usecase";
import { ResendDoctorAccountSetupEmailUsecase } from "@/domain/usecase/doctor/resend-doctor-account-setup-email-usecase";
import { UpdateDoctorUsecase } from "@/domain/usecase/doctor/update-doctor-usecase";
import { UpdatePasswordExpiryDateUsecase } from "@/domain/usecase/doctor/update-password-expiry-date-usecase";
import { FetchDashboardUsecase } from "@/domain/usecase/dashboard/fetch-dashboard-usecase";
import { SendNotificationUsecase } from "@/domain/usecase/dashboard/send-notification-usecase";
import { ActivatePatientUsecase } from "@/domain/usecase/patient/activate-patient-usecase";
import { FetchPatientListUsecase } from "@/domain/usecase/patient/fetch-patient-list-usecase";
import { FetchPatientUsecase } from "@/domain/usecase/patient/fetch-patient-usecase";
import { CreatePatientUsecase } from "@/domain/usecase/patient/create-patient-usecase";
import { DeactivatePatientUsecase } from "@/domain/usecase/patient/deactivate-patient-usecase";
import { ResendPatientAccountSetupSmsUsecase } from "@/domain/usecase/patient/resend-patient-account-setup-sms-usecase";
import { UpdatePatientUsecase } from "@/domain/usecase/patient/update-patient-usecase";
import { CancelPrescriptionUsecase } from "@/domain/usecase/prescription/cancel-prescription-usecase";
import { CreatePrescriptionUsecase } from "@/domain/usecase/prescription/create-prescription-usecase";
import { FetchActivityDetailUsecase } from "@/domain/usecase/prescription/fetch-activity-detail-usecase";
import { FetchEyeActivityDataUsecase } from "@/domain/usecase/prescription/fetch-eye-activity-data-usecase";
import { FetchPrescriptionDetailUsecase } from "@/domain/usecase/prescription/fetch-prescription-detail-usecase";
import { FetchPrescriptionListUsecase } from "@/domain/usecase/prescription/fetch-prescription-list-usecase";
import { SendPatientMessageUsecase } from "@/domain/usecase/prescription/send-patient-message-usecase";
import { SubmitActivityFeedbackUsecase } from "@/domain/usecase/prescription/submit-activity-feedback-usecase";
import { AddTreatmentUsecase } from "@/domain/usecase/treatment/add-treatment-usecase";
import { FetchTreatmentListUsecase } from "@/domain/usecase/treatment/fetch-treatment-list-usecase";
import { FinishTreatmentUsecase } from "@/domain/usecase/treatment/finish-treatment-usecase";
import { cryptoUtil } from "@/utils/crypto/crypto";
import { AES_KEY, FETCH_API_CLIENT_ENCRYPT_URL_STR } from "@/utils/global-constants";
import { decompressGzipData, isGzipUrl } from "@/utils/gzip-utils";
import { createLogger } from "@/utils/logger/logger";
import { translate } from "@/utils/i18n";
import { dispatchSessionAuthError } from "@/utils/session-auth-error";
import {
  FetchApiClient,
  FetchApiClientMethod,
  HttpError,
  TokenTransportConfig,
  TokenTransportType,
} from "@sadtx/fetch-api-client";
import { errorConverter, SATErrorModel, SATErrorType } from "@sadtx/sat-error";

export let exchangeAESKeyUsecase: ExchangeAESKeyUsecase;
export let initDoctorPasswordSettingUsecase: InitDoctorPasswordSettingUsecase;
export let refreshWebSessionUsecase: RefreshWebSessionUsecase;
export let browserEnvironmentCheckUsecase: BrowserEnvironmentCheckUsecase;
export let fetchWebUserInfoUsecase: FetchWebUserInfoUsecase;
export let loginUsecase: LoginUsecase;
export let logoutUsecase: LogoutUsecase;
export let changePasswordUsecase: ChangePasswordUsecase;
export let sendResetSnEmailUsecase: SendResetSnEmailUsecase;
export let issueWebFindSnLinkUsecase: IssueWebFindSnLinkUsecase;
export let issueFindSnPhoneAuthCodeUsecase: IssueFindSnPhoneAuthCodeUsecase;
export let issueWebFindSnEmailAuthCodeUsecase: IssueWebFindSnEmailAuthCodeUsecase;
export let checkFindSnPhoneAuthCodeUsecase: CheckFindSnPhoneAuthCodeUsecase;
export let changePasswordByVerificationTokenUsecase: ChangePasswordByVerificationTokenUsecase;
export let changePasswordByFindLinkUsecase: ChangePasswordByFindLinkUsecase;
export let fetchDashboardUsecase: FetchDashboardUsecase;
export let sendNotificationUsecase: SendNotificationUsecase;
export let fetchPatientListUsecase: FetchPatientListUsecase;
export let fetchPatientUsecase: FetchPatientUsecase;
export let createPatientUsecase: CreatePatientUsecase;
export let updatePatientUsecase: UpdatePatientUsecase;
export let resendPatientAccountSetupSmsUsecase: ResendPatientAccountSetupSmsUsecase;
export let activatePatientUsecase: ActivatePatientUsecase;
export let deactivatePatientUsecase: DeactivatePatientUsecase;
export let fetchPrescriptionListUsecase: FetchPrescriptionListUsecase;
export let fetchPrescriptionDetailUsecase: FetchPrescriptionDetailUsecase;
export let createPrescriptionUsecase: CreatePrescriptionUsecase;
export let cancelPrescriptionUsecase: CancelPrescriptionUsecase;
export let fetchActivityDetailUsecase: FetchActivityDetailUsecase;
export let fetchEyeActivityDataUsecase: FetchEyeActivityDataUsecase;
export let sendPatientMessageUsecase: SendPatientMessageUsecase;
export let submitActivityFeedbackUsecase: SubmitActivityFeedbackUsecase;
export let fetchDoctorListUsecase: FetchDoctorListUsecase;
export let fetchChargeDoctorListUsecase: FetchChargeDoctorListUsecase;
export let fetchDoctorUsecase: FetchDoctorUsecase;
export let createMedicalExpertUsecase: CreateMedicalExpertUsecase;
export let createNurseUsecase: CreateNurseUsecase;
export let createCroUsecase: CreateCroUsecase;
export let updateDoctorUsecase: UpdateDoctorUsecase;
export let activateDoctorUsecase: ActivateDoctorUsecase;
export let deactivateDoctorUsecase: DeactivateDoctorUsecase;
export let resendDoctorAccountSetupEmailUsecase: ResendDoctorAccountSetupEmailUsecase;
export let updatePasswordExpiryDateUsecase: UpdatePasswordExpiryDateUsecase;
export let fetchOperationLogUsecase: FetchOperationLogUsecase;
export let addTreatmentUsecase: AddTreatmentUsecase;
export let fetchTreatmentListUsecase: FetchTreatmentListUsecase;
export let finishTreatmentUsecase: FinishTreatmentUsecase;
export let addHospitalUsecase: AddHospitalUsecase;
export let fetchHospitalListUsecase: FetchHospitalListUsecase;
export let fetchHospitalUsecase: FetchHospitalUsecase;
export let deleteHospitalUsecase: DeleteHospitalUsecase;
export let createTempUserUsecase: CreateTempUserUsecase;
export let addAppAccountUsecase: AddAppAccountUsecase;
export let checkUserIdAvailableUsecase: CheckUserIdAvailableUsecase;
export let checkUserNameBySmsTokenForLoginAccountUsecase: CheckUserNameBySmsTokenForLoginAccountUsecase;
export let fetchPrivacyMdFileUsecase: FetchPrivacyMdFileUsecase;
export let fetchTermsOfServiceFileUsecase: FetchTermsOfServiceFileUsecase;
export let isExistAuthorizedTokenUsecase: IsExistAuthorizedTokenUsecase;
export let removeAuthorizedTokenUsecase: RemoveAuthorizedTokenUsecase;
export let saveTermsConsentUsecase: SaveTermsConsentUsecase;
export let setAuthorizedTokenUsecase: SetAuthorizedTokenUsecase;

let fetchApiClient: FetchApiClientMethod | null = null;
let initialized = false;
let initializePromise: Promise<void> | null = null;
const logger = createLogger("InitializeInstances");
const USECASE_EXECUTION_LOG_MODES = new Set(["debug", "qa"]);

type RepositoryInstances = {
  authRepo: AuthRepository;
  loginRepo: LoginRepository;
  dashboardRepo: DashboardRepository;
  patientRepo: PatientRepository;
  prescriptionRepo: PrescriptionRepository;
  doctorRepo: DoctorRepository;
  operationLogRepo: OperationLogRepository;
  treatmentRepo: TreatmentRepository;
  hospitalRepo: HospitalRepository;
  userRepo: UserRepository;
  userPasswordRepo: UserPasswordRepository;
  appAccountSettingRepo: AppAccountSettingRepository;
};

const tokenTransportConfig: TokenTransportConfig = {
  tokenTransportType: TokenTransportType.WEB_COOKIE,
};

function withUsecaseExecutionLog<T extends object>(name: string, usecase: T): T {
  return new Proxy(usecase, {
    get(target, propertyKey, receiver) {
      const value = Reflect.get(target, propertyKey, receiver);
      if (typeof value !== "function") return value;

      if (propertyKey === "execute") {
        return (...args: unknown[]) => {
          if (shouldLogUsecaseExecution()) {
            console.info("[SAT-014][Usecase]", `${name}.execute`);
          }
          return Reflect.apply(value, target, args);
        };
      }

      return value.bind(target);
    },
  });
}

function shouldLogUsecaseExecution(): boolean {
  const mode = import.meta.env.MODE.toLowerCase();
  return USECASE_EXECUTION_LOG_MODES.has(mode) || mode.endsWith("-qa");
}

function shouldUseMockApi(): boolean {
  return import.meta.env.MODE === "mock";
}

function handleApiClientError(error: unknown): void {
  const satError = errorConverter.convertError(error);
  dispatchSessionAuthError(satError);
}

function withSessionAuthErrorHandling(client: FetchApiClientMethod): FetchApiClientMethod {
  return new Proxy(client, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);
      if (typeof value !== "function") return value;

      return async (...args: unknown[]) => {
        try {
          return await value.apply(target, args);
        } catch (error: unknown) {
          handleApiClientError(error);
          throw error;
        }
      };
    },
  }) as FetchApiClientMethod;
}

function makeFetchApiClient(): FetchApiClientMethod {
  const client = new FetchApiClient(
    tokenTransportConfig,
    true,
    {
      checkTokenExpiredError: (error: HttpError) => {
        const requestUrl = error.config?.url ?? "";
        if (requestUrl.includes(URLList.USER.RESET_TOKEN)) {
          logger.debug("skip refresh retry for refresh endpoint failure", { url: requestUrl });
          return false;
        }

        const satError = errorConverter.convertError(error);
        logger.debug("token expiration check", {
          url: requestUrl,
          errorType: satError.type,
          message: satError.message,
        });
        return (
          satError.type === SATErrorType.ExpiredToken ||
          satError.type === SATErrorType.Unauthorized
        );
      },
      tokenReissueUrl: URLList.USER.RESET_TOKEN,
      errorMappers: {
        urlRequestIsEmpty: new SATErrorModel.UrlRequestIsEmpty(translate("error.requestEmpty")),
      },
    },
    {
      encryptUrlStr: FETCH_API_CLIENT_ENCRYPT_URL_STR,
      requestInterceptor: async (config) => {
        const aesSecretKey = await secureStorage.getItem(sessionStorage, AES_KEY);
        if (!aesSecretKey) {
          logger.warn("AES secret key not found before encrypted request", {
            url: config.url,
          });
          throw new SATErrorModel.FailToGetSecretKey();
        }

        if (config.data == null) return config;

        const isAlreadyEncrypted =
          typeof config.data === "object" &&
          config.data !== null &&
          "securePayload" in (config.data as Record<string, unknown>);

        if (isAlreadyEncrypted) return config;

        logger.debug("encrypt request payload", { url: config.url });
        const plainString =
          typeof config.data === "string" ? config.data : JSON.stringify(config.data);
        config.data = {
          securePayload: await cryptoUtil.encrypt(plainString, aesSecretKey),
        };
        return config;
      },
      responseInterceptor: async (response) => {
        const data = response.data as { securePayload?: string };
        if (!data?.securePayload) return response;

        const aesSecretKey = await secureStorage.getItem(sessionStorage, AES_KEY);
        if (!aesSecretKey) {
          logger.warn("AES secret key not found before encrypted response", {
            url: response.config?.url,
          });
          throw new SATErrorModel.FailToGetSecretKey();
        }

        logger.debug("decrypt response payload", { url: response.config?.url });
        const decryptedData = await cryptoUtil.decrypt(data.securePayload, aesSecretKey);
        const requestUrl = response.config?.url ?? "";
        const finalData = isGzipUrl(requestUrl)
          ? await decompressGzipData(decryptedData)
          : decryptedData;

        return {
          ...response,
          data: JSON.parse(finalData),
        };
      },
    },
    undefined,
    undefined,
  );
  return withSessionAuthErrorHandling(client);
}

export function getFetchApiClient(): FetchApiClientMethod {
  if (!fetchApiClient) {
    throw new Error("FetchApiClient is not initialized");
  }
  return fetchApiClient;
}

function makeMockRepositoryInstances(): RepositoryInstances {
  fetchApiClient = null;

  return {
    authRepo: new MockAuthRepositoryImpl(),
    loginRepo: new MockLoginRepositoryImpl(),
    dashboardRepo: new MockDashboardRepositoryImpl(),
    patientRepo: new MockPatientRepositoryImpl(),
    prescriptionRepo: new MockPrescriptionRepositoryImpl(),
    doctorRepo: new MockDoctorRepositoryImpl(),
    operationLogRepo: new MockOperationLogRepositoryImpl(),
    treatmentRepo: new MockTreatmentRepositoryImpl(),
    hospitalRepo: new MockHospitalRepositoryImpl(),
    userRepo: new MockUserRepositoryImpl(),
    userPasswordRepo: new MockUserPasswordRepositoryImpl(),
    appAccountSettingRepo: new AppAccountSettingRepositoryImpl(new AppAccountSettingSource()),
  };
}

function makeRemoteRepositoryInstances(): RepositoryInstances {
  fetchApiClient = makeFetchApiClient();

  const authSource = new AuthSource(fetchApiClient, cryptoUtil, secureStorage);
  const loginSource = new LoginSource(fetchApiClient);
  const dashboardSource = new DashboardSource(fetchApiClient);
  const patientSource = new PatientSource(fetchApiClient);
  const prescriptionSource = new PrescriptionSource(fetchApiClient);
  const doctorSource = new DoctorSource(fetchApiClient);
  const operationLogSource = new OperationLogSource(fetchApiClient);
  const treatmentSource = new TreatmentSource(fetchApiClient);
  const hospitalSource = new HospitalSource(fetchApiClient);
  const userSource = new UserSource(fetchApiClient);
  const userPasswordSource = new UserPasswordSource(fetchApiClient);
  const appAccountSettingSource = new AppAccountSettingSource();

  return {
    authRepo: new AuthRepositoryImpl(authSource),
    loginRepo: new LoginRepositoryImpl(loginSource),
    dashboardRepo: new DashboardRepositoryImpl(dashboardSource),
    patientRepo: new PatientRepositoryImpl(patientSource),
    prescriptionRepo: new PrescriptionRepositoryImpl(prescriptionSource),
    doctorRepo: new DoctorRepositoryImpl(doctorSource),
    operationLogRepo: new OperationLogRepositoryImpl(operationLogSource),
    treatmentRepo: new TreatmentRepositoryImpl(treatmentSource),
    hospitalRepo: new HospitalRepositoryImpl(hospitalSource),
    userRepo: new UserRepositoryImpl(userSource),
    userPasswordRepo: new UserPasswordRepositoryImpl(userPasswordSource),
    appAccountSettingRepo: new AppAccountSettingRepositoryImpl(appAccountSettingSource),
  };
}

function assignUsecases(repositories: RepositoryInstances): void {
  const {
    authRepo,
    loginRepo,
    dashboardRepo,
    patientRepo,
    prescriptionRepo,
    doctorRepo,
    operationLogRepo,
    treatmentRepo,
    hospitalRepo,
    userRepo,
    userPasswordRepo,
    appAccountSettingRepo,
  } = repositories;

  exchangeAESKeyUsecase = withUsecaseExecutionLog(
    "ExchangeAESKeyUsecase",
    new ExchangeAESKeyUsecase(authRepo),
  );
  initDoctorPasswordSettingUsecase = withUsecaseExecutionLog(
    "InitDoctorPasswordSettingUsecase",
    new InitDoctorPasswordSettingUsecase(userPasswordRepo),
  );
  refreshWebSessionUsecase = withUsecaseExecutionLog(
    "RefreshWebSessionUsecase",
    new RefreshWebSessionUsecase(authRepo, userRepo),
  );
  fetchWebUserInfoUsecase = withUsecaseExecutionLog(
    "FetchWebUserInfoUsecase",
    new FetchWebUserInfoUsecase(userRepo),
  );
  browserEnvironmentCheckUsecase = withUsecaseExecutionLog(
    "BrowserEnvironmentCheckUsecase",
    new BrowserEnvironmentCheckUsecase(),
  );
  loginUsecase = withUsecaseExecutionLog("LoginUsecase", new LoginUsecase(loginRepo, authRepo));
  logoutUsecase = withUsecaseExecutionLog("LogoutUsecase", new LogoutUsecase(loginRepo, authRepo));
  changePasswordUsecase = withUsecaseExecutionLog(
    "ChangePasswordUsecase",
    new ChangePasswordUsecase(userPasswordRepo),
  );
  sendResetSnEmailUsecase = withUsecaseExecutionLog(
    "SendResetSnEmailUsecase",
    new SendResetSnEmailUsecase(userPasswordRepo),
  );
  issueWebFindSnLinkUsecase = withUsecaseExecutionLog(
    "IssueWebFindSnLinkUsecase",
    new IssueWebFindSnLinkUsecase(userPasswordRepo),
  );
  issueFindSnPhoneAuthCodeUsecase = withUsecaseExecutionLog(
    "IssueFindSnPhoneAuthCodeUsecase",
    new IssueFindSnPhoneAuthCodeUsecase(userPasswordRepo),
  );
  issueWebFindSnEmailAuthCodeUsecase = withUsecaseExecutionLog(
    "IssueWebFindSnEmailAuthCodeUsecase",
    new IssueWebFindSnEmailAuthCodeUsecase(userPasswordRepo),
  );
  checkFindSnPhoneAuthCodeUsecase = withUsecaseExecutionLog(
    "CheckFindSnPhoneAuthCodeUsecase",
    new CheckFindSnPhoneAuthCodeUsecase(userPasswordRepo),
  );
  changePasswordByVerificationTokenUsecase = withUsecaseExecutionLog(
    "ChangePasswordByVerificationTokenUsecase",
    new ChangePasswordByVerificationTokenUsecase(userPasswordRepo),
  );
  changePasswordByFindLinkUsecase = withUsecaseExecutionLog(
    "ChangePasswordByFindLinkUsecase",
    new ChangePasswordByFindLinkUsecase(userPasswordRepo),
  );
  fetchDashboardUsecase = withUsecaseExecutionLog(
    "FetchDashboardUsecase",
    new FetchDashboardUsecase(dashboardRepo),
  );
  sendNotificationUsecase = withUsecaseExecutionLog(
    "SendNotificationUsecase",
    new SendNotificationUsecase(dashboardRepo),
  );
  fetchPatientListUsecase = withUsecaseExecutionLog(
    "FetchPatientListUsecase",
    new FetchPatientListUsecase(patientRepo),
  );
  fetchPatientUsecase = withUsecaseExecutionLog(
    "FetchPatientUsecase",
    new FetchPatientUsecase(patientRepo),
  );
  createPatientUsecase = withUsecaseExecutionLog(
    "CreatePatientUsecase",
    new CreatePatientUsecase(patientRepo),
  );
  updatePatientUsecase = withUsecaseExecutionLog(
    "UpdatePatientUsecase",
    new UpdatePatientUsecase(patientRepo),
  );
  resendPatientAccountSetupSmsUsecase = withUsecaseExecutionLog(
    "ResendPatientAccountSetupSmsUsecase",
    new ResendPatientAccountSetupSmsUsecase(patientRepo),
  );
  activatePatientUsecase = withUsecaseExecutionLog(
    "ActivatePatientUsecase",
    new ActivatePatientUsecase(patientRepo),
  );
  deactivatePatientUsecase = withUsecaseExecutionLog(
    "DeactivatePatientUsecase",
    new DeactivatePatientUsecase(patientRepo),
  );
  fetchPrescriptionListUsecase = withUsecaseExecutionLog(
    "FetchPrescriptionListUsecase",
    new FetchPrescriptionListUsecase(prescriptionRepo),
  );
  fetchPrescriptionDetailUsecase = withUsecaseExecutionLog(
    "FetchPrescriptionDetailUsecase",
    new FetchPrescriptionDetailUsecase(prescriptionRepo),
  );
  createPrescriptionUsecase = withUsecaseExecutionLog(
    "CreatePrescriptionUsecase",
    new CreatePrescriptionUsecase(prescriptionRepo),
  );
  cancelPrescriptionUsecase = withUsecaseExecutionLog(
    "CancelPrescriptionUsecase",
    new CancelPrescriptionUsecase(prescriptionRepo),
  );
  fetchActivityDetailUsecase = withUsecaseExecutionLog(
    "FetchActivityDetailUsecase",
    new FetchActivityDetailUsecase(prescriptionRepo),
  );
  fetchEyeActivityDataUsecase = withUsecaseExecutionLog(
    "FetchEyeActivityDataUsecase",
    new FetchEyeActivityDataUsecase(prescriptionRepo),
  );
  sendPatientMessageUsecase = withUsecaseExecutionLog(
    "SendPatientMessageUsecase",
    new SendPatientMessageUsecase(prescriptionRepo),
  );
  submitActivityFeedbackUsecase = withUsecaseExecutionLog(
    "SubmitActivityFeedbackUsecase",
    new SubmitActivityFeedbackUsecase(prescriptionRepo),
  );
  fetchDoctorListUsecase = withUsecaseExecutionLog(
    "FetchDoctorListUsecase",
    new FetchDoctorListUsecase(doctorRepo),
  );
  fetchChargeDoctorListUsecase = withUsecaseExecutionLog(
    "FetchChargeDoctorListUsecase",
    new FetchChargeDoctorListUsecase(doctorRepo),
  );
  fetchDoctorUsecase = withUsecaseExecutionLog(
    "FetchDoctorUsecase",
    new FetchDoctorUsecase(doctorRepo),
  );
  createMedicalExpertUsecase = withUsecaseExecutionLog(
    "CreateMedicalExpertUsecase",
    new CreateMedicalExpertUsecase(doctorRepo),
  );
  createNurseUsecase = withUsecaseExecutionLog(
    "CreateNurseUsecase",
    new CreateNurseUsecase(doctorRepo),
  );
  createCroUsecase = withUsecaseExecutionLog(
    "CreateCroUsecase",
    new CreateCroUsecase(doctorRepo),
  );
  updateDoctorUsecase = withUsecaseExecutionLog(
    "UpdateDoctorUsecase",
    new UpdateDoctorUsecase(doctorRepo),
  );
  activateDoctorUsecase = withUsecaseExecutionLog(
    "ActivateDoctorUsecase",
    new ActivateDoctorUsecase(doctorRepo),
  );
  deactivateDoctorUsecase = withUsecaseExecutionLog(
    "DeactivateDoctorUsecase",
    new DeactivateDoctorUsecase(doctorRepo),
  );
  resendDoctorAccountSetupEmailUsecase = withUsecaseExecutionLog(
    "ResendDoctorAccountSetupEmailUsecase",
    new ResendDoctorAccountSetupEmailUsecase(doctorRepo),
  );
  updatePasswordExpiryDateUsecase = withUsecaseExecutionLog(
    "UpdatePasswordExpiryDateUsecase",
    new UpdatePasswordExpiryDateUsecase(doctorRepo),
  );
  fetchOperationLogUsecase = withUsecaseExecutionLog(
    "FetchOperationLogUsecase",
    new FetchOperationLogUsecase(operationLogRepo),
  );
  addTreatmentUsecase = withUsecaseExecutionLog(
    "AddTreatmentUsecase",
    new AddTreatmentUsecase(treatmentRepo),
  );
  fetchTreatmentListUsecase = withUsecaseExecutionLog(
    "FetchTreatmentListUsecase",
    new FetchTreatmentListUsecase(treatmentRepo),
  );
  finishTreatmentUsecase = withUsecaseExecutionLog(
    "FinishTreatmentUsecase",
    new FinishTreatmentUsecase(treatmentRepo),
  );
  addHospitalUsecase = withUsecaseExecutionLog(
    "AddHospitalUsecase",
    new AddHospitalUsecase(hospitalRepo),
  );
  fetchHospitalListUsecase = withUsecaseExecutionLog(
    "FetchHospitalListUsecase",
    new FetchHospitalListUsecase(hospitalRepo),
  );
  fetchHospitalUsecase = withUsecaseExecutionLog(
    "FetchHospitalUsecase",
    new FetchHospitalUsecase(hospitalRepo),
  );
  deleteHospitalUsecase = withUsecaseExecutionLog(
    "DeleteHospitalUsecase",
    new DeleteHospitalUsecase(hospitalRepo),
  );
  createTempUserUsecase = withUsecaseExecutionLog(
    "CreateTempUserUsecase",
    new CreateTempUserUsecase(userRepo),
  );
  addAppAccountUsecase = withUsecaseExecutionLog(
    "AddAppAccountUsecase",
    new AddAppAccountUsecase(appAccountSettingRepo),
  );
  checkUserIdAvailableUsecase = withUsecaseExecutionLog(
    "CheckUserIdAvailableUsecase",
    new CheckUserIdAvailableUsecase(appAccountSettingRepo),
  );
  checkUserNameBySmsTokenForLoginAccountUsecase =
    withUsecaseExecutionLog(
      "CheckUserNameBySmsTokenForLoginAccountUsecase",
      new CheckUserNameBySmsTokenForLoginAccountUsecase(appAccountSettingRepo),
    );
  fetchPrivacyMdFileUsecase = withUsecaseExecutionLog(
    "FetchPrivacyMdFileUsecase",
    new FetchPrivacyMdFileUsecase(appAccountSettingRepo),
  );
  fetchTermsOfServiceFileUsecase = withUsecaseExecutionLog(
    "FetchTermsOfServiceFileUsecase",
    new FetchTermsOfServiceFileUsecase(appAccountSettingRepo),
  );
  isExistAuthorizedTokenUsecase = withUsecaseExecutionLog(
    "IsExistAuthorizedTokenUsecase",
    new IsExistAuthorizedTokenUsecase(appAccountSettingRepo),
  );
  removeAuthorizedTokenUsecase = withUsecaseExecutionLog(
    "RemoveAuthorizedTokenUsecase",
    new RemoveAuthorizedTokenUsecase(appAccountSettingRepo),
  );
  saveTermsConsentUsecase = withUsecaseExecutionLog(
    "SaveTermsConsentUsecase",
    new SaveTermsConsentUsecase(appAccountSettingRepo),
  );
  setAuthorizedTokenUsecase = withUsecaseExecutionLog(
    "SetAuthorizedTokenUsecase",
    new SetAuthorizedTokenUsecase(appAccountSettingRepo),
  );
}

export function initializeInstances(): Promise<void> {
  if (initialized) return Promise.resolve();
  if (initializePromise) return initializePromise;

  initializePromise = Promise.resolve().then(() => {
    const useMockApi = shouldUseMockApi();
    logger.info(useMockApi ? "mock repository mode enabled" : "remote repository mode enabled");

    assignUsecases(useMockApi ? makeMockRepositoryInstances() : makeRemoteRepositoryInstances());

    initialized = true;
  });

  return initializePromise;
}
